const HamburgerMenuIcon: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8H28" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M4 16H28" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M4 24H28" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
export default HamburgerMenuIcon;
